import React from 'react';
import TemplatePage from '../../components/TemplatePage/TemplatePage';
import { electronicsData } from '../../data/departmentalData/electronics';

const Electronics = () => {
  return <TemplatePage data={electronicsData} />;
};

export default Electronics;
